<template>
    <div class="wrapper">        
            <router-view v-slot="{ Component }">
                <transition
                    name="slide"
                    mode="out-in"            
                >
                    <component :is="Component" />
                </transition>
            </router-view>
        <!-- <Feedback></Feedback> -->
    </div>
</template>

<script>
// import Feedback from '../components/feedback.vue'
// export default {
//     components:{
//         Feedback
//     }
// }
</script>
<style lang="less" scoped>
    @import "assets/less/icon.less";
    .slide-enter-active,
    .slide-leave-active {
    transition: all 0.15s ease-out;
    }

    .slide-enter-to {
    position: absolute;
    right: 0;
    }

    .slide-enter-from {
    position: absolute;
    right: -100%;
    }

    .slide-leave-to {
    position: absolute;
    left: -100%;
    }

    .slide-leave-from {
    position: absolute;
    left: 0;
    }

    .opacity-0{
        opacity: 0;
    }
    .opacity-100{
        opacity: 1;
    }
    .wrapper{
        height: 100%;
        .home-wrapper{
            width: 100%;
            // background:#fff;
        }
        .placeholder{
            height: 175px;
            width:750px;
            bottom:0            
        }
    }
    .bottom-nav{
        position:fixed;
        bottom:0;
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        padding:30px 0 0;
        z-index: 99998;
        background:#fff;
        .nav-list{            
            .nav-element{
                width: 250px;
                height: 112px;
                float:left;
                // display:flex;
                justify-content: center;
                text-decoration:none;
                position: relative;
                .nav-text{
                    text-align: center;
                    color:#A59BB3;
                    font-size: 24px;
                    &.active{
                        color:#F0B30E;
                        font-size: 24px;
                    }
                }
                .additional{
                    position:absolute;
                    color:#fff;
                    padding:3px;
                    background: red;
                    font-size: 20px;
                    border-radius: 5px;
                    top:5px;
                    left:130px;
                    transform: rotate(0deg);
                }
            }
            &.router-link-exact-active{
                .nav-text{
                    color:#F0B30E;
                }
            }
        }

    }
</style>